export type ValueRecordToColorRecord<
  P extends string,
  R extends Record<string | number, string | number>
> = {
  [K in keyof R as K extends string ? `${P}${K}` : never]: string;
};

export function interpolateRecord<
  ValueRecord extends Record<string | number, string | number>,
  Prefix extends string
>(
  values: ValueRecord,
  prefix: Prefix,
  interpolator: (v: ValueRecord[keyof ValueRecord]) => string
): ValueRecordToColorRecord<Prefix, ValueRecord> {
  return Object.entries(values).reduce(
    (acc, [key, val]) => {
      acc[`${prefix}${key}`] = interpolator(
        val as ValueRecord[keyof ValueRecord]
      );
      return acc;
    },
    {} as Record<string, string>
  ) as ValueRecordToColorRecord<Prefix, ValueRecord>;
}
